















import radiobutton from './RadioButton.vue'

export default {
  name: 'RadioButtonGroup'
  props: [
    'id'
    'labels'
    'model'
    'name'
    'validate'
    'values',
    'value'
  ]
  components:
    'v-radiobutton': radiobutton
  methods:
    onInput: (val) ->
      @$emit 'input', val
      
  mounted: () ->
    componentHandler.upgradeElements @$el
}




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/form/RadioButtonGroup.vue